var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".identity-check[data-v-6f063326]{display:flex;align-items:center;justify-content:center;width:100%;min-height:100%;padding:50px 0;background:#fafafa url(" + escape(require("@/assets/images/detect/bg.png")) + ") no-repeat 50% 50%/auto 100%}.identity-check h2[data-v-6f063326]{font-weight:500;padding-top:34px}.main-content[data-v-6f063326]{width:1200px;min-height:670px;overflow:hidden;background-color:#fff;margin:0 auto;box-shadow:0 0 20px 0 rgba(57,126,253,.1);border-radius:8px;text-align:center}", ""]);

// exports
